export default __webpack_public_path__ + "static/media/BackwardVectorDark.c0e2683b.svg";